import loadable from '@loadable/component'

export const ImageGrid = loadable(() => import('./ImageGrid'))
export type { BoxCollectionProps, ImageGridProps } from './ImageGrid'
